import gql from 'graphql-tag';
import {
  analyticArguments,
  analyticArgumentsOnlineMedia,
  analyticArgumentsQuery,
  analyticArgumentsQueryOnlineMedia
} from '../analyticArgument';

// const analyticArgumentsQueryMedia = `
//   $projectId: Id!,
//   $start: Timestamp!,
//   $end: Timestamp!,
//   $mediaList: [String!]!,
//   $granularity: GranularityInput!,
//   $timezone: Int!,
//   $phrases: [String!],
//   $includeKeywords: [String!],
//   $excludeKeywords: [String!],
//   $searchType: SearchType
//   $sentiment: [Sentiment!],
//   $postOwnership: [PostOwnership!],
//   $labelList: [Id!],
//   $languageList: [String!],
//   $clippingId: Id,
//   $validationList: [ValidationType!],
//   $queryStringBooleanOperator: QueryStringBooleanOperator
//   `;

// const analyticArgumentsMedia = `
//   projectId: $projectId,
//   start: $start,
//   end: $end,
//   mediaList: $mediaList,
//   granularity: $granularity,
//   timezone: $timezone,
//   phrases: $phrases,
//   includeKeywords: $includeKeywords,
//   excludeKeywords: $excludeKeywords,
//   searchType: $searchType,
//   sentiment: $sentiment,
//   postOwnership: $postOwnership,
//   labelList: $labelList,
//   languageList: $languageList,
//   clippingId: $clippingId,
//   validationList: $validationList,
//   queryStringBooleanOperator: $queryStringBooleanOperator
//   `;

// const analyticArgumentsQueryMediaOffline = `
//   $projectId: Id!,
//   $start: Timestamp!,
//   $end: Timestamp!,
//   $mediaList: [String!]!,
//   $granularity: GranularityInput!,
//   $timezone: Int!,
//   $phrase: String!,
//   $sentiment: [Sentiment!],
//   $postOwnership: [PostOwnership!]
//   $labelList: [Id!]`;

// const analyticArgumentsMediaOffline = `
//   projectId: $projectId,
//   start: $start,
//   end: $end,
//   mediaList: $mediaList,
//   granularity: $granularity,
//   timezone: $timezone,
//   phrase: $phrase,
//   sentiment: $sentiment,
//   postOwnership: $postOwnership
//   labelList: $labelList`;

export const DOWNLOAD_CSV = gql`
  mutation download_createDownloadCsvJob(${analyticArgumentsQuery}, $email: String!, $templateName: DownloadTemplate,) {
    download_createDownloadCsvJob(${analyticArguments},email: $email, templateName: $templateName ) {
      id
      start
      end
      objectIdList
      status
      createdAt
    }
  }
`;

export const DOWNLOAD_CSV_JOB_FOR_MEDIA_ONLINE = gql`
  mutation download_createDownloadCsvJobForOnlineMedia(${analyticArgumentsQueryOnlineMedia}) {
    download_createDownloadCsvJobForOnlineMedia(${analyticArgumentsOnlineMedia}) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
    }
  }
`;

export const DOWNLOAD_SUMMARY_ONLINE_MEDIA = gql`
  mutation download_createDownloadSummaryOnlineMedia(
  ${analyticArgumentsQueryOnlineMedia},
  $page: Int!, 
  $limit: Int!,
  $logoUrl: String,
  $language: String,
  $footerTitle: String,
  $footerAddress: String
  ) {
    download_createDownloadSummaryOnlineMedia(
    ${analyticArgumentsOnlineMedia},
    page: $page, 
    limit: $limit,
    logoUrl: $logoUrl,
    language: $language,
    footerTitle: $footerTitle,
    footerAddress: $footerAddress
    ) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
      clippingId
    }
  }
`;

export const DOWNLOAD_SUMMARY_REPORT = gql`
  mutation Download_createDownloadSummary(
    $projectId: Id!
    $start: Timestamp!
    $end: Timestamp!
    $page: Int!
    $limit: Int!
    $socialMediaInput: SocialMediaInput
    $onlineMediaInput: OnlineMediaInput
    $printMediaInput: OfflineMediaInput
    $broadcastMediaInput: OfflineMediaInput
    $logoUrl: String
    $title: String
  ) {
    download_createDownloadSummary(
      projectId: $projectId
      start: $start
      end: $end
      page: $page
      limit: $limit
      socialMediaInput: $socialMediaInput
      onlineMediaInput: $onlineMediaInput
      printMediaInput: $printMediaInput
      broadcastMediaInput: $broadcastMediaInput
      logoUrl: $logoUrl
      title: $title
    ) {
      id
      title
      start
      end
      status
      createdAt
      link
    }
  }
`;

// export const DOWNLOAD_CSV_MEDIA_OFFLINE = gql`
//   mutation download_createDownloadCsvJobForOfflineMedia(${analyticArgumentsQueryMediaOffline}) {
//     download_createDownloadCsvJobForOfflineMedia(${analyticArgumentsMediaOffline}) {
//       id
//       start
//       end
//       mediaList
//       phrase
//       status
//       createdAt
//       link
//     }
//   }
// `;
